import { queryOptions, useQuery } from '@tanstack/react-query';

import { blocksApi } from '../api/content-api';

import { contentKeys } from './content-keys';

export function blockQueryOptions(storeId: string | null, id: string) {
  return queryOptions({
    queryKey: contentKeys.blockDetail(storeId, id),
    queryFn: () => blocksApi.get(storeId, id),
  });
}

export function useBlock(storeId: string | null, id: string) {
  return useQuery(blockQueryOptions(storeId, id));
}
